import React from 'react';
import { FiImage } from 'react-icons/fi';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';

const sortIconMap = {
	asc: <IoIosArrowRoundUp style={{ fontSize: '18px', fontWeight: '800' }} />,
	desc: <IoIosArrowRoundDown style={{ fontSize: '18px', fontWeight: '800' }} />,
};

const HeaderCell = ({ field, label, handleSort, sortDirection, isRight }) => (
	<div
		className={`d-flex align-items-center ${isRight ? 'justify-content-end gap-1' : 'justify-content-between'} w-100 cursor-pointer`}
		onClick={() => handleSort && handleSort(field)}
	>
		<span className="fw-bold text-dark">{label}</span>
		<span>{sortIconMap[sortDirection[field]]}</span>
	</div>
);

export const getListTableColumns = (handleSort, sortDirection = {}) => [
	{
		field: 'LIST NAME',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 240,
		flex: 1.5,
		checkboxSelection: true,
		headerCheckboxSelection: true,
		headerComponent: () => (
			<HeaderCell field="LIST NAME" label="LIST NAME" handleSort={handleSort} sortDirection={sortDirection} />
		),
		cellRenderer: (params) => (
			<div className="d-flex align-items-center gap-2">
				<div
					className="d-flex align-items-center justify-content-center rounded ms-1"
					style={{
						width: '28px',
						height: '28px',
						backgroundColor: '#e2e8f0',
						color: '#718096',
						fontSize: '14px',
					}}
				>
					<FiImage />
				</div>
				<span>{params.value}</span>
			</div>
		),
	},
	{
		field: 'DESCRIPTION',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 250,
		flex: 2,
		headerComponent: () => (
			<HeaderCell field="DESCRIPTION" label="DESCRIPTION" handleSort={handleSort} sortDirection={sortDirection} />
		),
	},
	{
		field: 'CREATED DATE',
		headerClass: 'HeaderBg',
		suppressSizeToFit: true,
		minWidth: 150,
		flex: 1,
		headerComponent: () => (
			<HeaderCell field="CREATED DATE" label="CREATED DATE" handleSort={handleSort} sortDirection={sortDirection} />
		),
	},
	{
		field: 'PRODUCT COUNT',
		headerClass: 'HeaderBg right-align',
		cellClass: 'right-align',
		suppressSizeToFit: true,
		minWidth: 150,
		flex: 1,
		headerComponent: () => (
			<HeaderCell field="PRODUCT COUNT" label="PRODUCT COUNT" handleSort={handleSort} sortDirection={sortDirection} isRight={true} />
		),
	},
];
